module.exports = __webpack_public_path__ + "img/comment.332f6f0f.png";